// src/routes/middleware/RoleBasedMiddleware.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleBasedMiddleware = ({ allowedRoles, children }) => {
  const role = localStorage.getItem("role");

  if (!allowedRoles.includes(parseInt(role))) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default RoleBasedMiddleware;
